import { render, staticRenderFns } from "./RubricPresetUnit.vue?vue&type=template&id=efc58304&scoped=true"
import script from "./RubricPresetUnit.vue?vue&type=script&lang=js"
export * from "./RubricPresetUnit.vue?vue&type=script&lang=js"
import style0 from "./RubricPresetUnit.vue?vue&type=style&index=0&id=efc58304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc58304",
  null
  
)

export default component.exports